// removed by extract-text-webpack-plugin
module.exports = {"markdown":"markdown__markdown____3QuqI"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/widgets/markdown-content/markdown.css
// module id = 403
// module chunks = 0